module.exports = __webpack_public_path__ + "f8be83fae6d60a148cff9957ac260a63.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/icon-user.svg
// module id = ./assets/images/header/icon-user.svg
// module chunks = 0